import React, {Component} from 'react';
import {Link, NavLink} from 'react-router-dom';
import { Navbar, Nav, Container }  from "react-bootstrap";

class MenuBottom extends Component {

  componentDidMount() {
    document.getElementById("root").scrollIntoView();
  }

  

  render(){
    

    return (

<Navbar id="MenuBottom" expand="lg" fixed="bottom" className="navbar navbar-expand d-md-none d-lg-none d-xl-none fixed-bottom shadow" 
style={{ 
  borderTopRightRadius: 20,
  borderTopLeftRadius: 20,
  borderBottomRightRadius: 20,
  borderBottomLeftRadius: 20,
  height: '80px',
  bottom: '10px',
  width: '95%',
  margin: 'auto',
  backgroundColor: "#c53c46",
  zIndex: 99
  }}>
  <Container>
<Nav className="navbar-nav nav-justified w-100 mb-2 mt-2 rounded">
  
  {JSON.parse(localStorage.getItem('menuBottom')).map((menuBottom,menuBottom_index) => {
    return (
        <NavLink key={menuBottom_index} as={Link} style={{ color : '#f2f2f2'}} activeStyle={{
          color: "#c53c46",
          backgroundColor: "#f2f2f2"
        }} activeClassName="active" target={menuBottom.target} className="nav-link font-weight-bold rounded" to={{ pathname: menuBottom.path }}>
            <i className={menuBottom.icon}></i>
            <span className="small d-block">{menuBottom.text}</span>
        </NavLink>
      )
  })}
  
 
  
</Nav>
</Container>
</Navbar>

            )
  }
}

export default MenuBottom;
